import { c as _c } from "react/compiler-runtime";
import type { Currency } from "@/features/currencies/types";
import { listingCurrencySymbol } from "@/features/finance/listing-currency";
import { isListingLive, type ListingRelation } from "@/features/finance/listing-status";
import { tokenAmount } from "@/lib/figure";

/** The asking price of a live listing, in the page's digits — or null for an NFT that is not for sale. */
export function listedPrice(listing: ListingRelation, isFa: boolean, currencies: Currency[] = []) {
  if (!isListingLive(listing)) return null;
  const text = tokenAmount((listing as {
    price_per_item?: unknown;
  }).price_per_item as string, isFa ? "fa-IR" : "en-US");
  return text ? {
    text,
    symbol: listingCurrencySymbol(listing, currencies)
  } : null;
}

/** A card's price strip: «قیمت», then the figure, large, on the plate — the row a listed card sells from. */
export function PriceRow(t0) {
  const $ = _c(12);
  const {
    price,
    isFa
  } = t0;
  const t1 = isFa ? "\u0642\u06CC\u0645\u062A" : "Price";
  let t2;
  if ($[0] !== t1) {
    t2 = <span className="v2-tile-ask-k">{t1}</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== price.text) {
    t3 = <bdi>{price.text}</bdi>;
    $[2] = price.text;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== price.symbol) {
    t4 = price.symbol ? <small>{price.symbol}</small> : null;
    $[4] = price.symbol;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <span className="v2-price v2-price--ask">{t3}{t4}</span>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <div className="v2-tile-meta v2-tile-ask">{t2}{t5}</div>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}

/** The token number on the picture's corner, where a listed card's body has no room left for it. */
export function TokenTag(t0) {
  const $ = _c(2);
  const {
    id
  } = t0;
  if (id === null || id === undefined || id === "") {
    return null;
  }
  let t1;
  if ($[0] !== id) {
    t1 = <span className="v2-tag v2-tag--token"><bdi dir="ltr">#{id}</bdi></span>;
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}